"use client";

import type { SearchEntry, GlobalSearchEmitFunction } from "../types";
import { GlobalSearchEvent } from "../types";
import {
  getAssetIcon,
  getAssetIconColor,
  GQL_TYPE_TO_ASSET_TYPE,
} from "../constants";
import { SearchResult } from "./SearchResult";
import { SearchSection } from "./SearchSection";

interface RecentlyUpdatedListProps {
  items: SearchEntry[];
  emit?: GlobalSearchEmitFunction;
}

/**
 * Recently-updated assets rendered as a React Aria `MenuSection`. Loading and
 * empty states are handled by the dropdown outside of the `Menu`.
 */
export function RecentlyUpdatedList({ items, emit }: RecentlyUpdatedListProps) {
  if (items.length === 0) return;

  return (
    <SearchSection title="Recently updated" id="recently-updated">
      {items.map((item: SearchEntry) => {
        if (!("id" in item)) return;

        const assetType = item.__typename
          ? GQL_TYPE_TO_ASSET_TYPE[item.__typename]
          : undefined;

        return (
          <SearchResult
            key={item.id}
            id={`recently-updated-${item.id}`}
            title={item.title || "Untitled"}
            href={item.url ?? "#"}
            icon={getAssetIcon(item)}
            iconColor={getAssetIconColor(assetType?.toLowerCase() ?? "")}
            updatedAt={item.updatedAt}
            onAction={() => {
              emit?.({
                event: GlobalSearchEvent.RecentlyUpdatedAssetClick,
                eventAction: "click",
                text: item.url ?? "#",
                customData: {
                  asset_type: assetType,
                  asset_id: item.id,
                },
              });
            }}
          />
        );
      })}
    </SearchSection>
  );
}
